export default [
    // *--------- Batch Production   ---- ---------------------------------------*
   
    {
        path: '/batchproduction/batchproduction-list',
        name: 'batchproduction-list',
        component: () => import('@/views/production/batchproduction/batchproduction.vue'),
        meta: {
            pageTitle: 'Batch Production List',
            breadcrumb: [
                {
                    text: 'Batch Production List',
                    active: true,
                },
            ],
            permission: 'Permissions.Production.View'  
        },
    },
]